import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_EXCURSION_OBJECT_URL } from '../apiUrl';

const uploadMasterDataPreviewExcursionObjectApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_EXCURSION_OBJECT_URL, data);
};

export default uploadMasterDataPreviewExcursionObjectApi;
